var isType = require('./isType');

module.exports = function isStruct(x) {
  return isType(x) && ( x.meta.kind === 'struct' );
};


//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/isStruct.js
// module id = 204
// module chunks = 0